// extracted by mini-css-extract-plugin
export var sliderRange = "_pw-2";
export var sliderRoot = "_pw-0";
export var sliderThumb = "_pw-3";
export var sliderTrack = "_pw-1";